/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付情報
 */
export interface Szoa308aResponseGasAceptSearchResultDtoAceptInfo {
    /**
     * 受付番号：数字
     */
    aceptNo?: string;
    /**
     * 受付履歴番号：数字
     */
    aceptRrkno?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
    /**
     * 更新区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C400010」のユーザコードを設定
     */
    updateDiv?: string;
    /**
     * 更新区分名称：全半角混在
     */
    updateDivAname?: string;
    /**
     * 内部お客さま番号：数字
     */
    visitNo?: string;
    /**
     * 使用お客さま番号：数字
     */
    logicDeviceNo?: string;
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo?: string;
    /**
     * 請求お客さま番号：数字
     */
    recptFixNo?: string;
    /**
     * 同時受付番号：数字
     */
    simltnAceptNo?: string;
    /**
     * 受付種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C401010」のユーザコードを設定
     */
    aceptClsfy?: string;
    /**
     * 受付種別コード名称：全半角混在
     */
    aceptClsfyAname?: string;
    /**
     * 受付日付：日付(yyyyMMdd)
     */
    aceptDate?: string;
    /**
     * 受付時刻：時刻(HHmm)
     */
    aceptHms?: string;
    /**
     * 受付担当組織番号：英数字
     */
    aceptSosikiCode?: string;
    /**
     * 受付担当社員番号：英数字
     */
    aceptStaffNo?: string;
    /**
     * 受付ステータス：英数字<br>　コード変換マスターテーブル.画面項目ID「C401020」のユーザコードを設定
     */
    aceptSts?: string;
    /**
     * 受付ステータス名称：全半角混在
     */
    aceptStsAname?: string;
    /**
     * 託送連絡要否フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C401030」のユーザコードを設定
     */
    cnscncYhiflg?: string;
    /**
     * 託送連絡要否フラグ名称：全半角混在
     */
    cnscncYhiflgAname?: string;
    /**
     * 異動保留要否フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C401040」のユーザコードを設定
     */
    rsfhruYhiflg?: string;
    /**
     * 異動保留要否フラグ名称：全半角混在
     */
    rsfhruYhiflgAname?: string;
    /**
     * お客さま承諾フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C400020」のユーザコードを設定
     */
    cstFlg?: string;
    /**
     * お客さま承諾フラグ名称：全半角混在
     */
    cstFlgAname?: string;
    /**
     * 開通受付番号：数字
     */
    provAceptNo?: string;
    /**
     * 開通受付履歴番号：数字
     */
    provAceptRrkno?: string;
    /**
     * 外部接続番号：英数字
     */
    extCnnctNo?: string;
}

